<template>
    <div class="flex flex-col">
        <div class="flex flex-row d-inline-flex gap-2">
            <user-avatar id="avatar"
                         :user="user"
                         displayName="true"
                         :time-ago="timeAgo"
                         subtitle="Assigned a Card Deck to">
            </user-avatar>
            <div style="min-width: 10px" class="dropdown-menu__status-dot"></div>
        </div>
        <div class="ms-5 d-flex flex-row flex-nowrap gap-1">
            <div>
                <inline-svg width="40" height="40" src="/assets/img/icons/file-heart-circle.svg"></inline-svg>
            </div>
            <div class="flex-1">
                <div>How to make pancakes</div>
                <div style="font-weight: 400;">8 cards</div>
            </div>
        </div>
    </div>
</template>
<script>
import {defineComponent} from 'vue'
import UserAvatar from "@/components/UserAvatar.vue";

export default defineComponent({
    name: "NotificationMenuItem",
    components: {UserAvatar},
    props: ['user', 'timeAgo']
})
</script>

<style scoped>

</style>
